import { ISportsBettingBaseApi, ReportedProblemType } from '../api/apiBase';
import { ILoggingService } from './loggingService';
import { IGroupedApi } from '../api/apiCommon';
import { IPlayer } from '../models/player';
export class UserService {

    public checkUserIdentityOnInit(userSecureIdFromWeb: string | null, userFromApi: IPlayer, loggingService: ILoggingService, api: IGroupedApi<ISportsBettingBaseApi>) {
        if ((!userFromApi && userSecureIdFromWeb) || (userFromApi && userSecureIdFromWeb !== userFromApi.SecureId)) {
            const text = `UserSecureIdFromWeb !== userFromApi ${userSecureIdFromWeb}, ${userFromApi?.SecureId}`;
            loggingService.error(text);
            const ctx = api.open();
            try {
                ctx.api.reportProblemToServer(ReportedProblemType.Error, text, 30000);
            } finally {
                ctx.close();
            }
        }
    }

}